import { render, staticRenderFns } from "./MarkerOcorrenciaComFoto.vue?vue&type=template&id=12b33fc5"
import script from "./MarkerOcorrenciaComFoto.vue?vue&type=script&lang=js"
export * from "./MarkerOcorrenciaComFoto.vue?vue&type=script&lang=js"
import style0 from "./MarkerOcorrenciaComFoto.vue?vue&type=style&index=0&id=12b33fc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports